const e = {
  undo: "Deshacer",
  redo: "Rehacer",
  confirm: "Confirmar",
  clear: "Borrar",
  more: "más",
  cancel: "Cancelar",
  update: "Actualizar"
}, a = {
  positiveText: "Confirmar",
  negativeText: "Cancelar"
}, r = {
  placeholder: "Seleccione",
  loading: "Cargando"
}, o = {
  clear: "Borrar",
  now: "Ahora",
  confirm: "Confirmar",
  selectTime: "Seleccionar hora",
  selectDate: "Seleccionar fecha",
  datePlaceholder: "Seleccionar fecha",
  datetimePlaceholder: "Seleccionar fecha y hora",
  monthPlaceholder: "Seleccionar mes",
  yearPlaceholder: "Seleccionar año",
  quarterPlaceholder: "Seleccionar Trimestre",
  startDatePlaceholder: "Fecha de inicio",
  endDatePlaceholder: "Fecha de finalización",
  startDatetimePlaceholder: "Fecha de inicio y hora",
  endDatetimePlaceholder: "Fecha y hora de finalización",
  startMonthPlaceholder: "Mes de inicio",
  endMonthPlaceholder: "Final de mes",
  today: "Hoy"
}, n = {
  checkTableAll: "Seleccionar todos en la tabla",
  uncheckTableAll: "Deseleccionar todo en la tabla",
  confirm: "Confirmar",
  clear: "Borrar",
  apply: "Aplicar",
  filters: "Filtros",
  sort: "Ordenar"
}, c = {
  sourceTitle: "Fuente",
  targetTitle: "Objetivo"
}, t = {
  selectAll: "Seleccionar todo",
  unselectAll: "Deseleccionar todo",
  clearAll: "Borrar"
}, i = {
  description: "Sin datos"
}, l = {
  placeholder: "Seleccione"
}, d = {
  placeholder: "Seleccionar hora",
  positiveText: "De acuerdo",
  negativeText: "Cancelar",
  now: "Ahora"
}, s = {
  goto: "Ir a",
  selectionSuffix: "página",
  next: "Siguiente",
  previous: "Anterior"
}, m = {
  add: "Añadir"
}, p = {
  loading: "Cargando"
}, h = {
  placeholder: "Introduzca"
}, g = {
  placeholder: "Introduzca"
}, u = {
  create: "Crear"
}, f = {
  title: "Editor de asuntos",
  clearAllVars: "Borrar Todas las Variables",
  clearSearch: "Borrar la búsqueda",
  filterCompName: "Filtrar nombre del componente",
  filterVarName: "Filtrar nombre de la variable",
  import: "Importar",
  export: "Exportar",
  restore: "Restablecer a los valores por defecto"
}, C = {
  tipPrevious: "Imagen anterior (←)",
  tipNext: "Siguiente imagen (→)",
  tipCounterclockwise: "En sentido antihorario",
  tipClockwise: "En sentido horario",
  tipZoomOut: "Alejar",
  tipZoomIn: "Acercar",
  tipClose: "Cerrar (Esc)",
  tipOriginalSize: "Zoom al tamaño original"
}, P = {
  heading: "Ordenar y filtrar",
  sortHeading: "Filtrar por",
  newestFirst: "Lo más reciente primero",
  oldestFirst: "Lo más antiguo primero",
  ascending: "Asc",
  descending: "Desc.",
  apply: "Aplicar",
  clear: "Borrar",
  cancel: "Cancelar",
  filters: "Filtros"
}, S = {
  noMatchingFound: "No se han encontrado resultados coincidentes"
}, T = {
  margin: "Margen",
  padding: "Espaciado del contenido",
  reset: "Restablecer",
  errorMsg: "El valor proporcionado no es válido."
}, A = {
  brandColors: "Colores de marca",
  noBrandColors: "Todavía no ha agregado ningún color de marca.",
  getStarted: "Empezar",
  add: "Añadir",
  default: "Por defecto"
}, b = {
  addColor: "Añadir Nuevo Color",
  editColor: "Editar Color",
  add: "Añadir",
  noData: "Aún no ha añadido ningún color.",
  invalidCode: "Código de color no válido",
  defaultColor: "Colores por defecto"
}, D = {
  global: e,
  Popconfirm: a,
  Cascader: r,
  DatePicker: o,
  DataTable: n,
  LegacyTransfer: c,
  Transfer: t,
  Empty: i,
  Select: l,
  TimePicker: d,
  Pagination: s,
  DynamicTags: m,
  Log: p,
  Input: h,
  InputNumber: g,
  DynamicInput: u,
  ThemeEditor: f,
  Image: C,
  SortFilter: P,
  IconPicker: S,
  Spacing: T,
  BrandColorPicker: A,
  BrandBoard: b
};
export {
  b as BrandBoard,
  A as BrandColorPicker,
  r as Cascader,
  n as DataTable,
  o as DatePicker,
  u as DynamicInput,
  m as DynamicTags,
  i as Empty,
  S as IconPicker,
  C as Image,
  h as Input,
  g as InputNumber,
  c as LegacyTransfer,
  p as Log,
  s as Pagination,
  a as Popconfirm,
  l as Select,
  P as SortFilter,
  T as Spacing,
  f as ThemeEditor,
  d as TimePicker,
  t as Transfer,
  D as default,
  e as global
};
